<!-- <p-toast [style]="{marginTop: '80px'}" life="3000"></p-toast> -->
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}


<div class="p-p-4">
  <form [formGroup]="form1">
    <p-fieldset styleClass="p-fluid" [toggleable]="false">
      <div class="p-fluid p-formgrid p-grid">

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <!-- <input formControlName="targetTotal" id="targetTotal" type="text" pInputText> -->
            <p-inputNumber  formControlName="targetTotal" [minFractionDigits]="0" id="targetTotal" [required]="true" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <!-- <label for="targetTotal">Enter New Proforma Target</label> -->
            @for (validation of validationMessages.targetTotal; track validation) {
              <span>
                @if (form1.get('targetTotal').hasError(validation.type) && (form1.get('targetTotal').dirty || form1.get('targetTotal').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="p-d-flex p-jc-end p-mt-4">
          @if (formErrorMessage) {
            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
          }
          <br>
            <button pButton type="button" label="Set Target" (click)="onFormSubmit()"></button>
          </div>
        </div>
      </p-fieldset>
    </form>
  </div>
